export default __webpack_public_path__ + "static/media/bin-picking.2b1dd18b.gif";